import { api } from "./api";

export interface GalleryImage {
  _id: string;
  storeId: string;
  name: string;
  url: string;
  thumbnailUrl?: string;
  type: "catalog" | "static";
  createdAt: string;
  updatedAt: string;
  usage?: {
    isUsed: boolean;
    usedInProducts: number;
    usedInCategories: number;
  };
}

export interface CreateGalleryImageRequest {
  name: string;
  url: string;
  thumbnailUrl?: string;
  type: "catalog" | "static";
}

export interface UploadGalleryImageRequest {
  file: File;
  name: string;
  type: "catalog" | "static";
}

export const galleryApi = {
  async getImages(type?: "catalog" | "static", includeUsage?: boolean): Promise<GalleryImage[]> {
    const params = new URLSearchParams();
    if (type) params.append("type", type);
    if (includeUsage) params.append("includeUsage", "true");
    const queryString = params.toString();
    const response = await api.get(`/admin/gallery${queryString ? `?${queryString}` : ""}`);
    return response.data;
  },

  async getImage(id: string): Promise<GalleryImage> {
    const response = await api.get(`/admin/gallery/${id}`);
    return response.data;
  },

  async createImage(data: CreateGalleryImageRequest): Promise<GalleryImage> {
    const response = await api.post("/admin/gallery", data);
    return response.data;
  },

  async uploadImage(data: UploadGalleryImageRequest): Promise<GalleryImage> {
    const formData = new FormData();
    formData.append("file", data.file);
    formData.append("name", data.name);
    formData.append("type", data.type);

    const response = await api.post("/admin/gallery/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  async updateImage(id: string, data: Partial<Pick<GalleryImage, "name" | "type">>): Promise<GalleryImage> {
    const response = await api.put(`/admin/gallery/${id}`, data);
    return response.data;
  },

  async deleteImage(id: string): Promise<void> {
    await api.delete(`/admin/gallery/${id}`);
  },
};

export interface BucketFile {
  key: string;
  url: string;
  thumbnailUrl?: string;
  size?: number;
  lastModified?: string;
  contentType?: string;
  isUsed: boolean;
  usedInProducts: number;
  usedInCategories: number;
  usedInAssets: number;
}

export const bucketApi = {
  async listFiles(): Promise<BucketFile[]> {
    const response = await api.get("/admin/gallery/bucket/files");
    return response.data;
  },

  async deleteFile(url: string): Promise<void> {
    await api.delete("/admin/gallery/bucket/files", { data: { url } });
  },
};
